import { magicLinkClient, oneTimeTokenClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

import { getApiUrl } from '@/utils/brand.util'

const getProdDomainHeaders = (): Record<string, string> => {
  if (typeof window === 'undefined') return {}
  const prodDomain = new URLSearchParams(window.location.search).get('prod-domain')
  return prodDomain ? { 'X-Prod-Domain': prodDomain } : {}
}

export const authClient = createAuthClient({
  baseURL: getApiUrl(),
  plugins: [magicLinkClient(), oneTimeTokenClient()],
  fetchOptions: {
    headers: getProdDomainHeaders(),
  },
  sessionOptions: {
    refetchOnWindowFocus: false,
  },
})
